import fetch from 'isomorphic-fetch';
import Config from '../../config/';
import language from '../../../components/locales';
import fs from 'fs';
import { detect } from 'detect-browser';
const browser = detect();

const API = {
  data: {
    async getAll(obj) {
      let response = await fetch(
        `${Config.api}/api/homologationVehicle/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();

      return {
        data: data.response,
        status: status
      };
    },
    async handleHomologation(item) {
      const response = await fetch(`${Config.api}/api/homologationVehicle`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Pragma: 'no-cache'
        }),
        body: JSON.stringify(item)
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleHomologationDownload(obj) {
      let response = await fetch(
        `${Config.api}/api/homologationVehicleFile/${JSON.stringify(obj)}`,
        {
          method: 'GET',
          'Content-Type': 'blob',
          headers: new Headers({ Pragma: 'no-cache' })
        }
      );
      var filename = `${language.account.createVehicules.downloadFileNameHomologation}.xlsx`;
      const status = response.status;
      const blob = await response.blob();
      var a = document.createElement('a');
      if (browser.name == 'ie') {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        a.setAttribute('href', window.URL.createObjectURL(blob));
        a.setAttribute('target', '_blank');
        a.setAttribute('download', filename);
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      return {
        data: 'ok',
        status: status
      };
    },
    async handleHomologationUpload(item) {
      const fullPath = document.getElementById('file').files;
      let formData = new FormData();
      formData.append('file', fullPath[0]);
      const response = await fetch(`${Config.api}/api/homologationVehicleFile`, {
        method: 'POST',
        body: formData,
        headers: new Headers({ Pragma: 'no-cache' })
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    }
  }
};
export default API;



// WEBPACK FOOTER //
// ./source/client/actions/homologation_vehicle/api/index.js